import { useMutation } from '@tanstack/react-query';

import { getSMPBackendAPIAdmin } from '@/proxy';

function setResourceLocations(resourceId: string, locationIds: string[]) {
  return getSMPBackendAPIAdmin().resourcesControllerSetLocationsV1(resourceId, { locationIds });
}

export function useSetResourceLocations() {
  return useMutation({
    mutationFn: ({ resourceId, locationIds }: { resourceId: string; locationIds: string[] }) =>
      setResourceLocations(resourceId, locationIds),
  });
}
